import React from "react";
import Tag from "../../../../generic/tag";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { ICommodity } from "../../../../types/components/orderBook/obTypes";
import { HOb2DGroupBy, HObGroupBy } from "../../../../service/orderBook/obGrpByHelper";
import obtradeRowSelection from "../../../../service/orderBook/selectAll";
import ObUtilHeader from "../../obContainer/obUtilHeader";
import DatePickerInt from "../../obContainer/obDatePickerInt";
import EdButton from "../../../../generic/edButton";
import { backButtonValue } from "../../obJsXConstants";
import ObCheckbox from "../../generic/obCheckbox";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import { ChipColorKeyComb, scrlStCls } from "../../obConstants";
import { toINR } from "../../../../service/numberFormat";
import ObCommDtlMob from "../../obDetails/mob/obCommDtlMob";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import { ChipStatusComb } from "./../../obConstants";
import ObToastMessPopup from "../../generic/obToastMessPopup";
import { ACommCancelAmoTrd, ACommCancelNrmTrd } from "../../../../service/orderBook/obApiService";
import ee from "../../../../utils/eventEmitter";
import indexer from "../../../../types/genericTypes";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";

export interface IObCommoditiesMobProps {
	// Array of Equity Data
	data: Array<any>;
	//true if table is history type else false
	isHistory?: boolean;
	hidePageNav?: (hide: boolean) => void;
	getDates: (frmDt: Date, toDate: Date) => void;
	reRenderCall?: (value: string) => void;
}

const ObCommoditiesMob: React.FC<IObCommoditiesMobProps> = props => {
	const [isSelectEnable, setIsSelectEnable] = React.useState(false);

	const [isAllDataSelected, setIsAllDataSelected] = React.useState(false);

	// wherever initial data needs to be sent, send initialData
	// initial data is array of array for supporting grouping
	const initialData = [props.data.map((data, index) => ({ ...data, id: index, isSelected: false }))];

	// tableData is shown in the table
	// tableData contains sorted, filtered, searched data
	let [tableData, setTableData] = React.useState(initialData);
	let CommHistoryData: Array<{ [x: string]: Array<ICommodity> }> = [{}];
	//selected count
	const [selectedCount, setselectedCount] = React.useState<number>(0);
	// show cancel popup
	const [showCancelPopup, setShowCancelPopup] = React.useState<{ bulkCancel: boolean; data?: any }>();

	//is popup data
	const [popupDataIndex, setPopupDataIndex] = React.useState<[number, number, string?]>();
	//executed orders count
	const exeCountRef = React.useRef();
	//Show Open Ords on Top or not ref state
	const OpenOrdsTopRef = React.useRef<boolean>();

	// this function excute on clicking any row
	function onRowClick(data: ICommodity, groupIndex: number, index: number, e?: any) {
		if (e && !e.nativeEvent.path.find((m: HTMLElement) => m.className && (m.className.indexOf("check") >= 0 || m.className.indexOf("menu") >= 0))) {
			setPopupDataIndex([groupIndex, index, props.isHistory && data.ordEntTyp ? data.ordEntTyp.split(" ")[0] : undefined]);
		}
	}

	React.useEffect(() => {
		setTableData([props.data]);
		//ref to initial toggle state of show open orders on top
		OpenOrdsTopRef.current = true;
		// check that props.data is not undefined/null, group it(open and others) and update tabledata

		if (props.data) {
			if (!props.isHistory) {
				let temp0 = HOb2DGroupBy(props.data, "sts");
				exeCountRef.current = temp0[1].length;
				setTableData(temp0);
			}
		}
		return () => {
			setTableData([[{}]]);
		};
	}, [props.data, props.isHistory]);
	//kept outside because state data updating in async mode
	if (props.isHistory) {
		CommHistoryData = tableData.map(group => HObGroupBy(group, "ordEntTyp", " "));
	}
	const selectRows = (groupIndex: number, index: number) => {
		const retRes = obtradeRowSelection(groupIndex, index, tableData, isAllDataSelected, "cancel", "true");

		// set the state
		setTableData(retRes.data);
		setselectedCount(retRes.count);

		setIsAllDataSelected(retRes.allSelected);
	};

	function onDataFilter(data: Array<any>, sText?: string, type?: string) {
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			const searchKeys: string = "symName;trdSym";

			data[0].forEach((ord: indexer) => {
				searchKeys.split(";").forEach((k: string) => {
					if (ord[k]) {
						ord[k] = SearchHighLight(ord[k], SearchText);
					}
				});
			});
		}
		if (type === "search" && OpenOrdsTopRef.current && !props.isHistory) {
			setTableData(HOb2DGroupBy(data[0], "sts"));
		} else {
			setTableData(data);
		}
	}

	function addFlAndNtQty(bulkCancel: boolean, data?: ICommodity) {
		let flQtySum = 0;
		let ntQtySum = 0;

		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: ICommodity) => {
					if (rw.isSelected) {
						flQtySum += +rw.flQty;
						ntQtySum += +(rw.ntQty ? rw.ntQty : rw.qtyTF || 0);
					}
				})
			);
		} else if (data) {
			flQtySum += +data.flQty;
			ntQtySum += +(data.ntQty ? data.ntQty : data.qtyTF || 0);
		}

		return { flQtySum, ntQtySum };
	}

	function selectedRows(bulkCancel: boolean, data?: ICommodity) {
		if (bulkCancel) {
			let total = 0;
			tableData.forEach((g: any) =>
				g.forEach((rw: ICommodity) => {
					if (rw.isSelected) {
						total++;
					}
				})
			);
			return total;
		} else if (data) {
			return 1;
		}
		return 0;
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			setShowCancelPopup(undefined); // close confirmation popup
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });

			props.reRenderCall && props.reRenderCall("today");
		}
	}

	function checkPartialOrder(bulkCancel: boolean, data?: ICommodity) {
		// <span>{data.flQty}</span>/<span>{data.ntQty ? data.ntQty : data.qtyTF}</span>
		const { flQtySum, ntQtySum } = addFlAndNtQty(bulkCancel, data);

		if (flQtySum === ntQtySum) {
			// not partially completed
			cancelOrder(bulkCancel, data?.ordID);
		} else {
			// partially completed
			setShowCancelPopup({ bulkCancel, data });
		}
	}

	function cancelOrder(bulkCancel: boolean, data?: any) {
		if (bulkCancel) {
			tableData.forEach((g: any) =>
				g.forEach((rw: ICommodity) => {
					if (rw.isSelected) {
						ordsListToCancel.push(rw.ordID);
						if (rw.ogt === "AMO") {
							// if amo trade then run this api
							ACommCancelAmoTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						} else {
							// if normal trade then run this api
							ACommCancelNrmTrd(cancelCallback, { nstOID: rw.ordID, exc: rw.exc, ordTyp: rw.ordTyp, prdCode: rw.prdCode });
						}
					}
				})
			);
		} else if (data) {
			// cancel single order
			ordsListToCancel.push(data?.ordID);
			if (data.ogt === "AMO") {
				// if amo trade then run this api
				ACommCancelAmoTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			} else {
				// if normal trade then run this api
				ACommCancelNrmTrd(cancelCallback, { nstOID: data.ordID, exc: data.exc, ordTyp: data.ordTyp, prdCode: data.prdCode });
			}
		}
	}

	function commRow(data: ICommodity, groupIndex: number, index: number) {
		return (
			<div className="com_mob new_offers_mob_con" key={index} onClick={e => onRowClick(data, groupIndex, index, e)}>
				{isSelectEnable ? (
					<div className="tag dtl_popup_action">
						<ObCheckbox name="CommTradeSelect" checked={data.isSelected} onChange={() => selectRows(groupIndex, index)} />
					</div>
				) : (
					<div className="tag">
						<Tag value={data.trsTyp[0]} shape="mini_circle" color={data.trsTyp === "BUY" ? "green" : "red"} height="30px" width="30px" />
					</div>
				)}
				<div className="new_offers_data">
					<div className="date">
						{data.rcvTim}
						{data.ordEntTyp && moment(dateTimeFormat(data.ordEntTyp)).format("HH:mm:ss")}
					</div>
					<div className="comp_con">
						<div className="sym" dangerouslySetInnerHTML={{ __html: data.symName ? data.symName : data.trdSym }}></div>
						{/* <span dangerouslySetInnerHTML={{ __html: data.symName ? data.symName : data.trdSym }}></span>
					<p className="sym_code" dangerouslySetInnerHTML={{ __html: data.trdSym }}></p> */}
						<div className="sts">
							<Tag value={ChipStatusComb[data.sts]} color={ChipColorKeyComb[data.sts.toLowerCase()]} />
						</div>
					</div>
					<div className="new_offers_values">
						<div className="prod_value">
							<span className="prod_type pd-r10">{data.prdCode}</span>
							<span>
								{data.flQty}
								{data.ntQty || (data.qtyTF && <span>/{data.ntQty ? data.ntQty : data.qtyTF}</span>)}
							</span>{" "}
							Qty @{/* <span>{data.prc ? "₹" + toINR(data.prc, 2) : "--"}</span> */}
						</div>
						<div className="amt">
							{data.avgPrc && data.avgPrc !== "--" && parseFloat(data.avgPrc) > 0 ? "₹" + toINR(data.avgPrc, 2) : "₹" + toINR(data.prc, 2)}
						</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className="instMobView eq_wrap_mob">
			{!isSelectEnable && (
				<ObUtilHeader
					leftSideText={
						!props.isHistory ? (
							<div className="executed">
								<span className="text">Executed Orders: </span>
								<span className="value">
									{exeCountRef.current} / {initialData[0].length}
								</span>
							</div>
						) : props.isHistory ? (
							<DatePickerInt plusDays={15} sendDates={props.getDates} />
						) : (
							<></>
						)
					}
					data={initialData}
					searchKey="cpName;dpName;trdSym"
					onDataFilter={onDataFilter}
					onSelectClick={
						!props.isHistory && tableData.find((g: any) => g.find((row: ICommodity) => row.cancel === "true"))
							? () => {
									setIsSelectEnable(true);
									props.hidePageNav && props.hidePageNav(true);
							  }
							: undefined
					}
					onFilterClick={tgl => {
						OpenOrdsTopRef.current = tgl;
					}}
					filterReqData={{
						status: "sts",
						aType: "comm",
						showOpenOrderOnTop: OpenOrdsTopRef.current,
						showOpenOrderTgl: props.isHistory ? false : true,
						isHistory: props.isHistory ? true : false
					}}
					onSearchClick={e => {
						setTableData(initialData);
						// if exists, then call it
						props.hidePageNav && props.hidePageNav(e);
					}}
				/>
			)}
			{isSelectEnable && (
				<>
					<div>
						<EdButton
							value={backButtonValue}
							btnTyp="link"
							onClick={() => {
								setIsSelectEnable(false);
								props.hidePageNav && props.hidePageNav(false);
							}}
							className="icon_button"
						/>

						<div className="toBtm">
							<EdButton
								type="button"
								btnTyp="primary"
								value="Cancel Orders"
								slim={false}
								disabled={selectedCount === 0 ? true : false}
								onClick={() => setIsSelectEnable(false)}
							/>
						</div>
					</div>
				</>
			)}
			{isSelectEnable && (
				<div className="check_box">
					<ObCheckbox name="eqTradeSelect" checked={isAllDataSelected} onChange={() => selectRows(-1, -1)}>
						Select All
					</ObCheckbox>
				</div>
			)}

			<div className="eq_wrap_mob">
				{props.isHistory
					? CommHistoryData.map((group: any, groupIndex: number) =>
							Object.keys(group).map((date: any, index: number) => {
								return (
									<>
										<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
											<li>{moment(dateTimeFormat(date)).format("DD MMMM YYYY")}</li>
										</ul>
										<ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
											{group[date].map((row: any, index: number) => (
												<React.Fragment key={index}>{commRow(row, groupIndex, index)}</React.Fragment>
											))}
										</ul>
									</>
								);
							})
					  )
					: !!tableData.length &&
					  tableData.map((group: any, groupIndex: number) => {
							return (
								<React.Fragment key={groupIndex}>
									{group.length > 0 && (
										<div key={groupIndex} className={"blockDivider child" + groupIndex}>
											{group.map((row: any, index: number) => (
												<React.Fragment key={index}>{commRow(row, groupIndex, index)}</React.Fragment>
											))}
										</div>
									)}
								</React.Fragment>
							);
					  })}
				{!tableData.length && <TocNoData data={initialData} callBackMeth={onDataFilter} />}
				{popupDataIndex && (
					<ObAssetDetailPopup>
						<ObCommDtlMob
							data={
								props.isHistory
									? CommHistoryData[popupDataIndex[0]][popupDataIndex[2]!][popupDataIndex[1]]
									: tableData[popupDataIndex[0]][popupDataIndex[1]]
							}
							onBackClick={() => setPopupDataIndex(undefined)}
							isTodayOrder={!props.isHistory}
							onCancelClick={() => checkPartialOrder(false, tableData[popupDataIndex[0]][popupDataIndex[1]] as ICommodity)}
						/>
					</ObAssetDetailPopup>
				)}
				{showCancelPopup && (
					<ObAssetDetailPopup>
						<ObToastMessPopup
							title={`Cancel ${selectedRows(showCancelPopup.bulkCancel, showCancelPopup.data)} Orders`}
							subtitle={`${addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).flQtySum}/${
								addFlAndNtQty(showCancelPopup.bulkCancel, showCancelPopup.data).ntQtySum
							} quantities have been partially executed. Are you sure you want to cancel the order?`}
							buttonValue="Yes, Confirm"
							btnTyp="secondary"
							onBackClick={() => setShowCancelPopup(undefined)}
							onToastBtnClick={() => cancelOrder(showCancelPopup.bulkCancel, showCancelPopup.data)}
						/>
					</ObAssetDetailPopup>
				)}
			</div>
		</div>
	);
};

export default ObCommoditiesMob;
